export const regionOptions = [
  {
    value: "en-CA",
    text: "EN",
  },
  {
    value: "fr-CA",
    text: "FR",
  },
];
